import pl from './pl';

export default {
  pl,
};
